package de.oevbs.kunde.kundenportal2.model.services.tax

import de.oevbs.kunde.kundenportal2.model.services.contract.CarContract
import de.oevbs.kunde.kundenportal2.validation.KupoValidationMessages
import dev.fritz2.core.Lenses
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.headless.validation.errorMessage
import dev.fritz2.validation.validation
import kotlinx.serialization.Serializable

@Lenses
@Serializable
data class YearContracts(
    val contracts: List<CarContract> = emptyList(),
    val invalidContractsCount: Int = 0 // Dem Kunden wird die Anzahl Verträge angezeigt, für die er nicht anfordern kann,
                                        // damit weniger Anrufe bei VuS eingehen wegen "fehlender Verträge".
) { companion object }

@Lenses
@Serializable
data class TaxInit(
    val yearsToContracts: Map<Int, YearContracts> = emptyMap()
) { companion object }

@Lenses
@Serializable
data class Tax(
    val selectedYear: Int,
    val selectedContracts: List<CarContract> = emptyList()
) {
    companion object {
        val validation = validation<Tax, ComponentValidationMessage> { inspector ->
            val selectedContracts = inspector.map(Tax.selectedContracts())
            val selectedYear = inspector.map(Tax.selectedYear())

            if (selectedYear.data == 0) {
                add(selectedYear.errorMessage(KupoValidationMessages.EMPTY_SELECT))
            }

            if (selectedContracts.data.isEmpty()) {
                add(selectedYear.errorMessage(KupoValidationMessages.EMPTY_SELECT))
            }
        }
    }
}

@Lenses
@Serializable
data class TaxResult(
    val failed: List<CarContract> = emptyList(),
    val successful: List<CarContract> = emptyList()
) { companion object }